<template>
  <transition name="leftSlide" appear>
    <div class="drawer">
      <list-menu
        class="drawer__menu"
        :menu-list="menuList"
        :font-color="fontColor"
        :icon-color="iconColor"
        :head-color="headColor"
        :hover-color="hoverColor"
        padding="20px"
        :has-line-campaign-banner="!isLoggedIn"
      />
    </div>
  </transition>
</template>

<script>
import ListMenu from './ListMenu'

export default {
  name: 'drawer',
  components:{
    ListMenu
  },
  data() {
    return {
    }
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array,
      default(){
        return []
      }
    }
  },
  computed: {
    fontColor(){
      if(Object.keys(this.colorScheme).length > 0 && this.colorScheme.fontColor){
        return this.colorScheme.fontColor
      }else{
        return '#434a54'
      }
    },
    iconColor(){
      if(Object.keys(this.colorScheme).length > 0 && this.colorScheme.keyColor){
        return this.colorScheme.keyColor
      }else{
        return '#ff7497'
      }
    },
    headColor(){
      if(Object.keys(this.colorScheme).length > 0 && this.colorScheme.keyColor){
        return this.colorScheme.keyColor
      }else{
        return '#ff7497'
      }
    },
    hoverColor(){
      const defGrad = 'linear-gradient(59.75deg, #fff3f5 21.4%, #f9f4fd 76.64%)'
      if(Object.keys(this.colorScheme).length > 0){
        if(!!this.colorScheme.hoverColor){
          return this.colorScheme.hoverColor
        }else{
          if(!!this.colorScheme.gradStart && /#[0-9a-z]{6}/i.test(this.colorScheme.gradStart)
             && !!this.colorScheme.gradEnd && /#[0-9a-z]{6}/i.test(this.colorScheme.gradEnd)
          ){
            const stMtc = this.colorScheme.gradStart.match(/#([0-9a-z]{2})([0-9a-z]{2})([0-9a-z]{2})/i)
            const endMtc = this.colorScheme.gradEnd.match(/#([0-9a-z]{2})([0-9a-z]{2})([0-9a-z]{2})/i)
            if(!!stMtc && stMtc.length === 4 && !!endMtc && endMtc.length === 4){
              console.log(parseInt(stMtc[1], 16), parseInt(stMtc[2], 16), parseInt(stMtc[3], 16))
              const baseAlpha = 0.1
              return `linear-gradient(59.75deg, rgba(${parseInt(stMtc[1], 16)},${parseInt(stMtc[2], 16)},${parseInt(stMtc[3], 16)},${baseAlpha}) 21.4%, rgba(${parseInt(endMtc[1], 16)},${parseInt(endMtc[2], 16)},${parseInt(endMtc[3], 16)},${baseAlpha}) 76.64%)`
            }else{
              return defGrad
            }
          }else{
            return defGrad
          }
        }
      }else{
        return defGrad
      }
    },
  },
  methods: {
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.drawer{
  height: 100%;
  width: 100%;
  position: fixed;
  background: $col_white;

  @include mq('pc') {
    max-width: 320px;
    box-shadow: 10px 0 20px rgba(0, 0, 0, 0.1);
  }

  &__menu{
    height: 100%;
    padding-bottom: 50px !important;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    pointer-events: auto;
  }
}

.leftSlide-enter-active, .leftSlide-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.leftSlide-enter, .leftSlide-leave-to {
  transform: translateX(-100vw) translateX(0px);
  @include mq('pc') {
    transform: translateX(-300px) translateX(0px);
  }
}

ul {
  list-style: none;
  margin: 16px 0 28px;
  padding-left: 34px;
}
a{
  text-decoration: none;
  color:white;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/Drawer.vue